export default {"src":"/_next/static/media/pergola.578682fc.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};